import type { PreferencesAction, PreferencesState } from './types'
import { PreferencesActionTypes } from './types'

export const initialPreferencesState: PreferencesState = {
  mealPlans: null,
  settings: null,
  privacy: null,
  library: null,
  home: null,
  loading: true,
  error: null
}

export function preferencesReducer(state: PreferencesState, action: PreferencesAction): PreferencesState {
  switch (action.type) {
    case PreferencesActionTypes.SET:
      return {
        ...state,
        mealPlans: action.payload.mealPlans,
        settings: action.payload.settings,
        privacy: action.payload.privacy,
        library: action.payload.library,
        home: action.payload.home,
        loading: false,
        error: null
      }
    case PreferencesActionTypes.SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case PreferencesActionTypes.CLEAR:
      return { ...initialPreferencesState }
    default:
      return state
  }
}
